/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var QtyHelper = /** @class */ (function () {
        function QtyHelper() {
        }
        QtyHelper.stripNonNumericCharacters = function (value) {
            return value.toString().replace(/\D/g, '');
        };
        QtyHelper.getGramsFromQty = function (qty) {
            return parseInt(QtyHelper.stripNonNumericCharsFromString(qty.toString())) * 100;
        };
        QtyHelper.stripNonNumericCharsFromString = function (numberStr) {
            return numberStr.replace(/\D/g, '');
        };
        QtyHelper.formatGrams = function (grams) {
            if (this.isKg(grams)) {
                return this.formatKg(grams);
            }
            else {
                return grams.toString() + ' g.';
            }
        };
        QtyHelper.isKg = function (grams) {
            return grams >= 1000;
        };
        QtyHelper.formatKg = function (grams) {
            return (grams / 1000).toFixed(1).toString().replace('.', ',') + ' kg.';
        };
        QtyHelper.getKgPriceFromGramPrice = function (price) {
            var kgPrice = price * 10;
            return this.thousandSeperatedNumber(kgPrice);
        };
        QtyHelper.thousandSeperatedNumber = function (value) {
            var ret = QtyHelper.stripNonNumericCharacters(value);
            return ret.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        };
        QtyHelper.getKrKgLabel = function () {
            return ' kr/kg';
        };
        return QtyHelper;
    }());

    MoyaComponents.register('store.price', function (el) {
        var priceMan = new PriceMan({
            priceElm: el.querySelector('.price .n'),
            unitLabel: el.querySelector('.price .c'),
            unit: el.dataset.unit,
        });
        priceMan.run();
    });
    var PriceMan = /** @class */ (function () {
        function PriceMan(config) {
            this.unitLabel = config.unitLabel;
            this.priceElm = config.priceElm;
            this.unit = config.unit;
        }
        PriceMan.prototype.run = function () {
            if (this.unit === '100g') {
                var price = parseInt(QtyHelper.stripNonNumericCharsFromString(this.priceElm.innerHTML));
                this.priceElm.innerHTML = QtyHelper.getKgPriceFromGramPrice(price);
                this.unitLabel.innerHTML = QtyHelper.getKrKgLabel();
            }
        };
        return PriceMan;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
